import api from 'api/client';
import { ENDPOINTS } from 'api/endpoints';
import { Category } from 'types/category';

const categoryService = {
  getCategories: async (): Promise<Category[]> => {
    const response = await api.get<Category[]>(ENDPOINTS.CATEGORIES);
    return response.data;
  },

  getCategoryBySlug: async (slug: string): Promise<Category> => {
    const response = await api.get<Category>(ENDPOINTS.CATEGORY_BY_SLUG(slug));
    return response.data;
  },
};

export default categoryService;
